
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IScheduleConflictData } from '../../models';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';

export interface ScheduleConflictDialogDataDialogData {
  type: 'confirmation';
  title: string;
  subtitle?: string;
  yesButtonText?: string;
  noButtonText?: string;
  conflict_data: IScheduleConflictData[]
}

@Component({
  selector: 'app-zignflix-schedule-conflict-dialog',
  imports: [
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatRadioModule,
    FormsModule
  ],
  templateUrl: './zignflix-schedule-conflict-dialog.component.html',
  styleUrl: './zignflix-schedule-conflict-dialog.component.scss'
})
export class ZignflixScheduleConflictDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ZignflixScheduleConflictDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ScheduleConflictDialogDataDialogData
  ) {
    this.data.conflict_data = this.data.conflict_data.map(x => {
      x.replace = false;
      x.play_untill = x.play_untill ? true : false;
      return x;
    })
  }

  onYesClick() {
    this.dialogRef.close(this.data.conflict_data);
  }

  onNoClick() {
    this.dialogRef.close(null);
  }

  selectAction(item: IScheduleConflictData, action: 'replace' | 'play_untill'): void {
    item.replace = action === 'replace';
    item.play_untill = action === 'play_untill' && item.is_play_untill;
  }

  onReplaceChange(item: IScheduleConflictData) {
    this.data.conflict_data = this.data.conflict_data.map(x => {
      if (item.screen_id === x.screen_id && item.broadcast_id === x.broadcast_id) {
        x.play_untill = item?.replace == true ? false : x.play_untill;
      }
      return x;
    })
  }

  onPlayUntilChange(item: IScheduleConflictData) {
    this.data.conflict_data = this.data.conflict_data.map(x => {
      if (item.screen_id === x.screen_id && item.broadcast_id === x.broadcast_id) {
        x.replace = item?.play_untill == true ? false : x.replace;
      }
      return x;
    })
  }

  getContainerHeight() {
    return (window.innerHeight - 460);
  }

  isPlayUntillTrueExists() {
    return this.data.conflict_data.some(x => x.play_untill);
  }

  isReplaceTrueExists() {
    return this.data.conflict_data.some(x => x.replace);
  }

}
